import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {map, Observable} from 'rxjs';
import { OrganizationModel } from '../models/organization.model';
import { environment } from "../../environments/environment";
import { PaginatedResponse } from "../models/paginated-response";
import { Pagination } from "../shared/interfaces/pagination";

@Injectable()
export class OrganizationDataSource {

  constructor(
    private http: HttpClient
  ) {
  }

  getOrganizations(pagination: Pagination = {}, nameFilter?: string): Observable<PaginatedResponse<OrganizationModel>> {
    const params = {};
    if (pagination?.pageNumber) {
      params['pageNumber'] = pagination.pageNumber;
    }

    if (pagination?.removeLimit) {
      params['removeLimit'] = pagination.removeLimit;
    }

    if (pagination?.pageSize) {
      params['pageSize'] = pagination.pageSize;
    }

    if (nameFilter && nameFilter !== '') {
      params['name'] = nameFilter;
    }

    return this.http.get<PaginatedResponse<OrganizationModel>>(
      environment.backendApi + 'api/Organization/GetOrganizations',
      {params}
    );
  }


  getOrganization(organizationId: number): Observable<OrganizationModel> {
    return this.http.get<OrganizationModel>(environment.backendApi + 'api/Organization/GetOrganization/' + organizationId);
  }

  /**
   * A wrapper around `getOrganization()` that returns a pseudo-paginated response containing the organization data.
   *
   * @param {number} organizationId - The unique identifier of the organization to retrieve.
   * @return {Observable<PaginatedResponse<OrganizationModel>>} An observable emitting a paginated response containing the organization data.
   */
  getOrganizationPaged(organizationId: number): Observable<PaginatedResponse<OrganizationModel>> {
    return this.getOrganization(organizationId)
      .pipe(
        map(org => {
          if (org) {
            return (
              {
                data: [org],
                pageNumber: 0,
                pageSize: 1,
                totalPages: 1,
                totalRecords: 1
              } as PaginatedResponse<OrganizationModel>
            );
          } else {
            return (
              {
                data: [],
                pageNumber: 0,
                pageSize: 0,
                totalPages: 0,
                totalRecords: 0
              } as PaginatedResponse<OrganizationModel>
            );
          }
        })
      );
  }

  deleteOrganization(organizationId: number): Observable<void> {
    return this.http.delete<void>(environment.backendApi + 'api/Organization/Delete/' + organizationId);
  }

  createOrganization(organizationName: string): Observable<OrganizationModel> {
    return this.http.post<OrganizationModel>(`${environment.backendApi}api/Organization`, {organizationName});
  }
}

